import 'react-international-phone/style.css';
import { MotionConfig } from 'framer-motion';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { RouterPaths } from './components/Router/Router.constants';
import Router from './components/Router/Router.component';
import './lib/analytics/analytics.service.ts';
import './lib/facebook/facebook.ts';
import Providers from './providers/Providers.component';
import { PerfRouteObserver } from './lib/perf/PerfRouteObserver.component';
import { ReloadRouteObserver } from './lib/perf/ReloadRouteObserver.component';

const PaymentSuccess = lazy(
  () => import('./pages/PaymentSuccess/PaymentSuccess.page.tsx'),
);
const Recorder = lazy(
  () => import('./pages/Recorder/Recorder.page.tsx'),
);

export default function App() {
  return (
    // framer-motion ignores the OS "reduce motion" setting unless told: with
    // "user" it drops transform and layout animation and keeps opacity and
    // color (design system contract, accessibility hard rule 4).
    <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <PerfRouteObserver />
        <Routes>
          <Route
            path={RouterPaths.paymentSuccess}
            element={
              <Suspense>
                <ReloadRouteObserver><PaymentSuccess /></ReloadRouteObserver>
              </Suspense>
            }
          />
          <Route
            path={RouterPaths.recorder}
            element={
              <Suspense>
                <ReloadRouteObserver><Recorder /></ReloadRouteObserver>
              </Suspense>
            }
          />
          <Route
            path="*"
            element={
              <Providers>
                <Router />
              </Providers>
            }
          />
        </Routes>
      </BrowserRouter>
    </MotionConfig>
  );
}
